import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { getExpense } from "../../utility";
import DialogData from "../../components/expense/dialogContent";
import ExpenseDialog from "../../components/expense/dialog";
import { crud } from "../../utility";
import { DatePicker } from "@mui/x-date-pickers";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

export default function Expense() {
  const location = useLocation();
  const navigate = useNavigate();
  const checkDate = location.state ? moment(location.state.date) : moment();
  const [curMonth, setCurMonth] = useState(checkDate.format("MM"));
  const [curYear, setCurYear] = useState(checkDate.format("YYYY"));
  const [overall, setOverall] = useState({});
  const [total, setTotal] = useState();
  const [date, setDate] = useState(checkDate);
  const [saveLoading, setSaveLoading] = useState(false);
  const [cashRecords, setCashRecords] = useState([]);
  const [open, setOpen] = useState(false);
  const methods = ["cash", "credit card", "bank transfer"];
  const types = [
    "Transportation",
    "Food",
    "Social",
    "Shopping",
    "Others",
    "Investment",
    "Fun",
    "Fixed Expense",
    "Daily",
  ];

  const initialRow = {
    year: moment().format("YYYY"),
    date: parseInt(moment().format("DD")),
    month: moment().format("MM"),
    method: methods[0],
    amount: "",
    type: types[0],
    note: "",
  };

  const [newRow, setNewRow] = useState(initialRow);

  const color = {
    Transportation: "#ef8f8f",
    Food: "#e0975f",
    Social: "#d8b24a",
    Shopping: "#8fae5c",
    Others: "#5fae8c",
    Investment: "#4f9d9d",
    Fun: "#5f93c4",
    "Fixed Expense": "#6f7fc4",
    Daily: "#a97fc4",
  };

  useEffect(() => {
    fetchExpense();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curMonth, curYear]);

  function fetchExpense() {
    getExpense().then((res) => {
      setCashRecords(res);
      getOverall(curMonth, curYear, res);
    });
  }

  const handleClose = () => {
    setOpen(false);
    setNewRow(initialRow);
  };

  function getOverall(month, year, res) {
    let all = {};
    let sum = 0;
    Object.keys(color).map((c) => (all[c] = 0));
    const curdata = res.filter((f) => f.month === month && f.year === year);
    curdata.map((c) => {
      all[c.type] = (all[c.type] || 0) + c.amount;
      sum += c.amount;
      return all;
    });
    let sort = Object.entries(all);
    sort.sort((a, b) => b[1] - a[1]);
    sort = Object.fromEntries(sort);
    setOverall(sort);
    setTotal(sum);
  }

  function getMonth(e) {
    setDate(e);
    setCurMonth(moment(e).format("MM"));
    setCurYear(moment(e).format("YYYY"));
  }

  function getData(type) {
    let filter = cashRecords.filter(
      (r) => r.type === type && r.month === curMonth && r.year === curYear
    );
    filter.sort((a, b) => a.date - b.date);
    let curDate = moment(date).format("YYYY-MM");
    navigate("/expense/details", {
      state: { data: filter, date: curDate, type: type },
    });
  }

  function handleInput(event, key) {
    let val = event.target.value;
    let newData = { ...newRow };
    if (key === "amount") {
      val = parseInt(val) || "";
    }
    newData[key] = val;
    setNewRow(newData);
  }

  const handleSave = () => {
    setSaveLoading(true);
    crud("/expense/create", newRow, false);
    setTimeout(() => {
      fetchExpense();
      setSaveLoading(false);
      handleClose();
    }, 2000);
  };

  const currency = (number) => {
    return number
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(number)
      : "$0";
  };

  return (
    <Box>
      <Grid container px={{ xs: 1, sm: 2 }} spacing={1} alignItems="center">
        <Grid item xs={12} md={8}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            <DatePicker
              views={["year", "month"]}
              value={date}
              format="YYYY-MM"
              onChange={(e) => getMonth(e)}
              slotProps={{ textField: { size: "small" } }}
            />
            <Button
              variant="outlined"
              onClick={() => setOpen(true)}
              endIcon={<AddIcon />}
            >
              Add
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={4} sx={{ textAlign: { xs: "left", md: "right" } }}>
          <Typography fontWeight={"bold"} fontSize={14}>
            Total Expense: {currency(total)}
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        {Object.keys(overall).map((o, index) => (
          <Grid item md={3} xs={6} p={1.5} key={o + index}>
            <Paper
              variant="outlined"
              sx={{ p: 1.5, height: 92, borderRadius: 2 }}
            >
              <Button
                sx={{
                  fontSize: 11,
                  color: "text.secondary",
                  p: 0,
                  minWidth: 0,
                  "&:hover": { backgroundColor: "transparent" },
                }}
                startIcon={
                  <Box
                    component="span"
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: color[o],
                    }}
                  />
                }
                onClick={() => getData(o)}
              >
                {o}
              </Button>
              <Typography fontSize={22} fontWeight={700} textAlign={"center"}>
                {currency(overall[o])}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <ExpenseDialog
        open={open}
        handleClose={handleClose}
        title="Create a new entry"
        subTitle="please note that amount is requried"
        content={<DialogData row={newRow} handleInput={handleInput} />}
        handleSave={handleSave}
        saveLoading={saveLoading}
        disable={!newRow.amount}
      />
    </Box>
  );
}
